import { clamp } from "@utils/number-utils";

const HEX_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const HEX_3_REGEX = /^#[A-Fa-f0-9]{3}$/;

// Takes an hex formatted color (i.e: #AABBCC) and an alpha value between 0 and 1
// The result is a hex formatted color with alpha channel (i.e: #AABBCC20)
export const colorWithAlpha = (color: string, alpha: number): string => {
	if (!HEX_REGEX.test(color)) return color;
	const hexColor = HEX_3_REGEX.test(color) ? convertHex3toHex6(color) : color;
	const transparencyBase256 = Math.floor(clamp(alpha, 0, 1) * 255);
	const transparencyHexCode = transparencyBase256.toString(16).padStart(2, "0");
	return `${hexColor}${transparencyHexCode}`;
};

const convertHex3toHex6 = (hex: string): string => `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
